import React from 'react';
import { getDomainType } from './utils/domainUtils';

/**
 * This component is designed to be extremely simple,
 * with no dependencies on browser APIs, so React Snap can pre-render it.
 * 
 * It shows different content based on the detected domain type.
 */
const Prerender = () => {
  // Get the current domain type
  const domainType = getDomainType();
  
  return (
    <div id="prerendered-content" style={{ margin: '20px' }}>
      {domainType === 'default' && (
        <>
          <h1>Welcome to NioPractice</h1>
          <p>
            Adaptive and interactive self-study tools to ace any test. 
            AI-powered learning platform for personalized practice and improvement.
          </p>
          <div className="prerendered-indicator">
            This content was pre-rendered for faster loading.
          </div>
        </>
      )}
      
      {domainType === 'ssc' && (
        <>
          <h1>SSC Preparation Resources | NioPractice</h1>
          <p>
            Adaptive and interactive tools to crack SSC. Practice with 
            AI-powered tests, track your progress, and master every topic for SSC exams.
          </p>
          <div className="ssc-specific-content">
            <h2>Top SSC Exams</h2>
            <ul>
              <li>SSC CGL (Combined Graduate Level)</li>
              <li>SSC CHSL (Combined Higher Secondary Level)</li>
              <li>SSC MTS (Multi-Tasking Staff)</li>
              <li>SSC CPO (Central Police Organization)</li>
            </ul>
          </div>
          <div className="prerendered-indicator">
            This SSC-specific content was pre-rendered for faster loading.
          </div>
        </>
      )}
      
      {domainType === 'gate' && (
        <>
          <h1>GATE Preparation Resources | NioPractice</h1>
          <p>
            Prepare for GATE with AI-powered practice tests. Comprehensive coverage 
            of CS subjects, previous year questions, and detailed solutions.
          </p>
          <div className="gate-specific-content">
            <h2>Top GATE Subjects</h2>
            <ul>
              <li>Computer Science and Information Technology</li>
              <li>Electronics and Communication</li>
              <li>Electrical Engineering</li>
              <li>Mechanical Engineering</li>
            </ul>
          </div>
          <div className="prerendered-indicator">
            This GATE-specific content was pre-rendered for faster loading.
          </div>
        </>
      )}
    </div>
  );
};

export default Prerender; 